export default __webpack_public_path__ + "static/media/i109vp.00ccb0f5.webp";